import { useEffect, useState } from "react";
import Global from "../global";
import { isLoggedin } from "../components/api/core";
import { VideoStore } from "../components/store/videoStore";
import InPlayer from "../components/backend/inplayer";

export default function useCheckBoxedVideo(video) {
  const [response, SetResponse] = useState("");

  useEffect(() => {
    async function checkAccess(assetId) {
      await InPlayer.Asset.checkAccessForAsset(assetId)
        .then((data) => {
          SetResponse("Access");
        })
        .catch((error) => {
          SetResponse("Premium");
        });
    }
    if (video) {
      if (Global.SUBSCRIPTION && Global.LOGIN) {
        SetResponse("Access");
      } else {
        if (
          (Global.SUBSCRIPTION || Global.LOGIN) &&
          video.playlist[0].ContentType === "Authenticated"
        ) {
          if (!isLoggedin()) {
            SetResponse("Login");
          } else {
            SetResponse("Access");
          }
        } else if (
          (Global.SUBSCRIPTION || Global.LOGIN) &&
          video.playlist[0].ContentType === "Premium"
        ) {
          if (VideoStore !== null) {
            if (isLoggedin()) {
              if (
                VideoStore.video_id !== video.playlist[0].mediaid ||
                VideoStore.payment.item.id !== video.playlist[0].AssetId
              ) {
                checkAccess(video.playlist[0].AssetId);
              } else {
                SetResponse("Access");
              }
            } else {
              SetResponse("Login with Premium");
            }
          } else {
            if (isLoggedin()) {
              checkAccess(video.playlist[0].AssetId);
            } else {
              SetResponse("Login with Premium");
            }
          }
        } else {
          SetResponse("Access");
        }
      }
    } else {
    }
  }, [video]);

  return response;
}
